import { MemCommonMentionKind } from "@mem-labs/common-editor";
import { MDSComboboxMention } from "../../forms";

export const extractCollectionMentions = (mentions: MDSComboboxMention[]) => {
  return mentions
    .filter(mention => mention.kind === MemCommonMentionKind.Collection)
    .map(mention => ({
      kind: "COLLECTION" as const,
      collection_id: mention.collection_id,
      collection_title: mention.collection_title,
    }));
};

export const extractNoteMentions = (mentions: MDSComboboxMention[]) => {
  return mentions
    .filter(mention => mention.kind === MemCommonMentionKind.Note)
    .map(mention => ({
      kind: "NOTE" as const,
      note_id: mention.note_id,
      note_primary_label: mention.note_primary_label,
    }));
};
